@if (portfolio && portfolio.id) {
  <router-outlet></router-outlet>
}
